<link rel="ractive" href="../r-page.html" name="r-page">
<link rel="ractive" href="../components/header.html" name="c-gp-header">
<link rel="ractive" href="../components/footer.html" name="c-gp-footer">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/jumbotron.html" name="c-gp-jumbotron">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-globalping-sponsors">
		<c-gp-jumbotron className="sponsors" gridType="type4"></c-gp-jumbotron>

		<h1 class="gp-sponsors_header">Our Sponsors</h1>

		<div class="gp-sponsors_main-info">
			<div class="gp-sponsors_main-info_descr">
				As an open-source project that relies on the community to operate, we are also highly appreciative of larger organizations that support our work.
			</div>

			<div class="gp-sponsors_main-info_list-wrapper">
				<span class="gp-sponsors_main-info_list-wrapper_title">
					Globalping sponsors can be listed here for considerable and ongoing contributions to the project in the form of:
				</span>

				<div class="gp-sponsors_main-info_list-wrapper_list">
					<span class="gp-sponsors_main-info_list-wrapper_list_item">
						<img src="{{@shared.assetsHost}}/img/check.svg" width="20" height="20">
						<span>Infrastructure, like servers and services</span>
					</span>

					<span class="gp-sponsors_main-info_list-wrapper_list_item">
						<img src="{{@shared.assetsHost}}/img/check.svg" width="20" height="20">
						<span>Mass hosting of probes managed by us</span>
					</span>

					<span class="gp-sponsors_main-info_list-wrapper_list_item">
						<img src="{{@shared.assetsHost}}/img/check.svg" width="20" height="20">
						<span>Grants and ongoing sponsorships</span>
					</span>

					<span class="gp-sponsors_main-info_list-wrapper_list_item">
						<img src="{{@shared.assetsHost}}/img/check.svg" width="20" height="20">
						<span>Developer hours and code contributions</span>
					</span>
				</div>
			</div>

			<div class="gp-sponsors_main-info_contact-us">
				<span>Contact us at</span>

				<a href="mailto:d@globalping.io" class="gp-sponsors_main-info_contact-us_mail">
					<img src="{{@shared.assetsHost}}/img/mail-icon.svg" width="20" height="20">
					<span>d@globalping.io</span>
				</a>
			</div>
		</div>

		<div class="gp-sponsors_sponsors-list">
			<div class="gp-sponsors_sponsors-list_platinum">
				<div class="gp-sponsors_sponsors-list_platinum_title">PLATINUM</div>

				<div class="gp-sponsors_sponsors-list_platinum_list">
					{{#each platinumSponsors}}
						<div class="gp-sponsors_sponsors-list_platinum_list_item">
							<div class="gp-sponsors_sponsors-list_platinum_list_item_logo">
								<img title="{{this.imgTitle}}"
									width="{{this.imgWidth}}"
									height="{{this.imgHeight}}"
									src="{{@shared.assetsHost}}{{this.imgSrc[0]}}"
									{{#if this.imgSrc[1]}}
										srcset="{{@shared.assetsHost}}{{this.imgSrc[1]}}"
									{{/if}}
									loading="lazy"/>
							</div>

							<p class="gp-sponsors_sponsors-list_platinum_list_item_descr">
								{{this.spDescr}}
							</p>

							<span class="gp-sponsors_sponsors-list_platinum_list_item_link">
								<img src="{{@shared.assetsHost}}/img/link-icon.svg" width="20" height="20">

								<a href="{{this.href}}" target="_blank" rel="noreferrer">{{this.linkDisplayed}}</a>
							</span>
						</div>
					{{/each}}

					<div class="gp-sponsors_sponsors-list_platinum_list_item become-a-sponsor">
						<span class="gp-sponsors_sponsors-list_platinum_list_item_title">Become a sponsor</span>
						<span class="gp-sponsors_sponsors-list_platinum_list_item_descr">
							Developer hours, donations, servers, and partnerships.
						</span>
					</div>
				</div>
			</div>

			<div class="gp-sponsors_sponsors-list_gold">
				<div class="gp-sponsors_sponsors-list_gold_title">GOLD</div>

				<div class="gp-sponsors_sponsors-list_gold_list">
					{{#each goldSponsors}}
						<div class="gp-sponsors_sponsors-list_gold_list_item">
							<div class="gp-sponsors_sponsors-list_gold_list_item_logo">
								<img title="{{this.imgTitle}}"
									width="{{this.imgWidth}}"
									height="{{this.imgHeight}}"
									src="{{@shared.assetsHost}}{{this.imgSrc[0]}}"
									{{#if this.imgSrc[1]}}
										srcset="{{@shared.assetsHost}}{{this.imgSrc[1]}}"
									{{/if}}
									loading="lazy"/>
							</div>

							<p class="gp-sponsors_sponsors-list_gold_list_item_descr">
								{{this.spDescr}}
							</p>

							<span class="gp-sponsors_sponsors-list_gold_list_item_link">
								<img src="{{@shared.assetsHost}}/img/link-icon.svg" width="20" height="20">

								<a href="{{this.href}}" target="_blank" rel="noreferrer">{{this.linkDisplayed}}</a>
							</span>
						</div>
					{{/each}}

					<div class="gp-sponsors_sponsors-list_gold_list_item become-a-sponsor">
						<span class="gp-sponsors_sponsors-list_gold_list_item_title">Become a sponsor</span>
						<span class="gp-sponsors_sponsors-list_gold_list_item_descr">
							Developer hours, donations, servers, and partnerships.
						</span>
					</div>
				</div>
			</div>

			<div class="gp-sponsors_sponsors-list_bronze">
				<div class="gp-sponsors_sponsors-list_bronze_title">BRONZE</div>

				<div class="gp-sponsors_sponsors-list_bronze_list">
					{{#each bronzeSponsors}}
						<div class="gp-sponsors_sponsors-list_bronze_list_item">
							<a class="gp-sponsors_sponsors-list_bronze_list_item_logo" target="_blank" rel="noopener noreferrer" href="{{this.href}}">
								<img title="{{this.imgTitle}}"
									width="{{this.imgWidth}}"
									height="{{this.imgHeight}}"
									src="{{@shared.assetsHost}}{{this.imgSrc[0]}}"
									{{#if this.imgSrc[1]}}
										srcset="{{@shared.assetsHost}}{{this.imgSrc[1]}}"
									{{/if}}
									loading="lazy"/>
							</a>
						</div>
					{{/each}}

					<div class="gp-sponsors_sponsors-list_bronze_list_item become-a-sponsor">
						<span class="gp-sponsors_sponsors-list_bronze_list_item_title">Become a sponsor</span>
						<span class="gp-sponsors_sponsors-list_bronze_list_item_descr">
							Developer hours, donations, servers, and partnerships.
						</span>
					</div>
				</div>
			</div>
		</div>

		<div class="gp-sponsors_help-us">
			<img width="40"
				height="40"
				src="{{@shared.assetsHost}}/img/heart.svg"
				loading="lazy" />

			<span class="gp-sponsors_help-us_text">
				Help us make Globalping even better
			</span>

			<a href="https://github.com/sponsors/jsdelivr" target="_blank" class="gp_btn_green">Become our sponsor</a>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	component.exports = {
		data () {
			return {
				title: 'Our Sponsors - Globalping',
				description: 'Globalping is sponsored by Datapacket, Gcore, and other awesome companies.',
				platinumSponsors: [
					{
						href: 'https://www.datapacket.com/',
						linkDisplayed: 'datapacket.com',
						imgTitle: 'Sponsored by Datapacket',
						imgWidth: 263,
						imgHeight: 38,
						imgSrc: [ '/img/sponsors/datapacket.svg' ],
						spDescr: 'DataPacket - one partner for global infrastructure. Dedicated servers with local routing in 67 global locations. Expert account teams and always-on support.',
					},
					{
						href: 'https://oneprovider.com/',
						linkDisplayed: 'oneprovider.com',
						imgTitle: 'Sponsored by OneProvider',
						imgWidth: 243,
						imgHeight: 64,
						imgSrc: [ '/img/sponsors/oneprovider.svg' ],
						spDescr: 'OneProvider provides worldwide hosting services with dedicated servers available in over 140 locations and its OneCloud VPS service in more than 60 locations.',
					},
					{
						href: 'https://www.fastly.com/',
						linkDisplayed: 'fastly.com',
						imgTitle: 'Sponsored by Fastly',
						imgWidth: 150,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/fastly.svg' ],
						spDescr: 'Fastly\'s edge cloud platform powers fast, secure, and scalable digital experiences.',
					},
				],
				goldSponsors: [
					{
						href: 'https://gcore.com/',
						linkDisplayed: 'gcore.com',
						imgTitle: 'Sponsored by Gcore',
						imgWidth: 182,
						imgHeight: 54,
						imgSrc: [ '/img/sponsors/gcore.svg' ],
						spDescr: 'Gcore accelerates AI training, provides comprehensive cloud services, improves content delivery, and protects servers and applications.',
					},
				],
				bronzeSponsors: [
					{
						href: 'https://xtom.com',
						imgTitle: 'Sponsored by xTom',
						imgWidth: 216,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/xtom.svg' ],
					},
					{
						href: 'https://looking.house',
						imgTitle: 'Sponsored by Looking.house',
						imgWidth: 222,
						imgHeight: 50,
						imgSrc: [ '/img/sponsors/looking-house.svg' ],
					},
					{
						href: 'https://www.starrydns.com',
						imgTitle: 'Sponsored by StarryDNS',
						imgWidth: 229,
						imgHeight: 40,
						imgSrc: [ '/img/sponsors/starry.png' ],
					},
					{
						href: 'https://www.ip2location.io/',
						imgTitle: 'Sponsored by IP2Location',
						imgWidth: 241,
						imgHeight: 40,
						imgSrc: [ '/img/sponsors/ip2location.svg' ],
					},
					{
						href: 'https://www.exoscale.com',
						imgTitle: 'Sponsored by Exoscale',
						imgWidth: 262,
						imgHeight: 35,
						imgSrc: [ '/img/sponsors/exoscale.svg' ],
					},
					{
						href: 'https://www.fdcservers.net',
						imgTitle: 'Sponsored by FDCServers',
						imgWidth: 205,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/fdc.svg' ],
					},
					{
						href: 'https://ipinfo.io/',
						imgTitle: 'Sponsored by IPInfo',
						imgWidth: 200,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/ipinfo.svg' ],
					},
					{
						href: 'https://www.edisglobal.com/',
						imgTitle: 'Sponsored by EDIS Global',
						imgWidth: 196,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/edis-global.svg' ],
					},
					{
						href: 'https://www.misaka.io',
						imgTitle: 'Sponsored by Misaka Network, Inc.',
						imgWidth: 203,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/misaka.svg' ],
					},
					{
						href: 'https://zappiehost.com',
						imgTitle: 'Sponsored by Zappie Host',
						imgWidth: 208,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/zappiehost.png' ],
					},
					{
						href: 'https://shockhosting.com/',
						imgTitle: 'Sponsored by Shock Hosting',
						imgWidth: 268,
						imgHeight: 40,
						imgSrc: [ '/img/sponsors/shockhosting.svg' ],
					},
					{
						href: 'https://www.dnsfilter.com/',
						imgTitle: 'Sponsored by DNSFilter',
						imgWidth: 214,
						imgHeight: 50,
						imgSrc: [ '/img/sponsors/dnsfilter.png' ],
					},
					{
						href: 'https://ipgeolocation.io/',
						imgTitle: 'Sponsored by IP Geolocation',
						imgWidth: 121,
						imgHeight: 70,
						imgSrc: [ '/img/sponsors/ipgeolocation.svg' ],
					},
					{
						href: 'https://cloudlooking.glass/',
						imgTitle: 'Sponsored by Cloud Looking Glass',
						imgWidth: 221,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/cloud-looking-glass.png' ],
					},
					{
						href: 'https://onidel.com/',
						imgTitle: 'Sponsored by Onidel',
						imgWidth: 244,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/onidel.svg' ],
					},
					{
						href: 'https://www.kuroit.com/',
						imgTitle: 'Sponsored by Kuroit',
						imgWidth: 226,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/kuroit.png' ],
					},
					{
						href: 'https://exservers.net/',
						imgTitle: 'Sponsored by ExServers',
						imgWidth: 250,
						imgHeight: 45,
						imgSrc: [ '/img/sponsors/exservers.png' ],
					},
					{
						href: 'https://netshop-isp.com.cy/',
						imgTitle: 'Sponsored by NetShop ISP',
						imgWidth: 217,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/netshop-logo-dark.svg' ],
					},
					{
						href: 'https://www.host-stage.net/',
						imgTitle: 'Sponsored by HostStage',
						imgWidth: 259,
						imgHeight: 55,
						imgSrc: [ '/img/sponsors/host-stage.svg' ],
					},
					{
						href: 'https://www.mvps.net/',
						imgTitle: 'Sponsored by MVPS',
						imgWidth: 253,
						imgHeight: 80,
						imgSrc: [ '/img/sponsors/mvps.svg' ],
					},
					{
						href: 'https://www.iplocate.io/',
						imgTitle: 'Sponsored by IPLocate',
						imgWidth: 252,
						imgHeight: 42,
						imgSrc: [ '/img/sponsors/iplocate.svg' ],
					},
					{
						href: 'https://breezehost.io/',
						imgTitle: 'Sponsored by BreezeHost',
						imgWidth: 204,
						imgHeight: 77,
						imgSrc: [ '/img/sponsors/breezehost.svg' ],
					},
					{
						href: 'https://www.digiturunc.com/',
						imgTitle: 'Sponsored by Digiturunc',
						imgWidth: 200,
						imgHeight: 92,
						imgSrc: [ '/img/sponsors/digiturunc.png' ],
					},
					{
						href: 'https://perlod.com/',
						imgTitle: 'Sponsored by Perlod',
						imgWidth: 210,
						imgHeight: 60,
						imgSrc: [ '/img/sponsors/perlod.svg' ],
					},
				],
			};
		},
	};
</script>
